import React from "react";
import { connect } from "react-redux";
import {
  addOrderData,
  setPlaceOrderData,
  setHasBag,
  setFormattedAddress,
  setUserLocation,
  resetSelectedPickup,
  resetSelectedDelivery,
  resetAvailableDeliveryDate,
  resetAvailablePickupDate,
} from "../../../redux/actions";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import { urlQuery } from "../../../utils/helpers";

import translation from "../../../translations/FirstStep";
import mailImg from "../../../images/mail_letter.jpg";

class FirstStep extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount = async () => {
    this.selectService("IO");

    this.props.history.push(urlQuery({ page: "select-service" }));
    try {
      window.dataLayer.push({ event: "service-select" });
    } catch (err) {
      console.log("Error", err);
    }
  };

  selectService = (val) => {
    const { orderData, addOrderData } = this.props;
    const data = { ...orderData, ...{ [`${val}`]: true } };

    return addOrderData(data);
  };

  render() {
    return (
      <div className="first-option-block">
        <HasBagBlock {...this.props} />
      </div>
    );
  }
}

const HasBagBlock = (props) => {
  const {
    setHasBag,
    hasBag,
    resetSelectedPickup,
    resetSelectedDelivery,
    resetAvailablePickupDate,
    resetAvailableDeliveryDate,
  } = props;
  const lang = localStorage.getItem("lang");

  const choiceHasBag = (hasBag) => {
    console.log("choiceHasBag");
    setHasBag(hasBag);
    resetSelectedPickup();
    resetSelectedDelivery();
    resetAvailablePickupDate();
    resetAvailableDeliveryDate();
  };

  return (
    <div className="checkout-has-bag-block">
      <div className="checkout-has-bag-info">
        <div className="checkout-has-bag-select-container-wrapper">
          <div className="checkout-has-bag-header">
            <p>{translation.hasBagTitleCompany[lang]}</p>
          </div>
          <div className="checkout-has-bag-select-container-block">
            <div className="checkout-has-bag-select-container">
              <div
                id="checkout-step-3-services-checkbox-has-bag"
                className={`checkout-has-bag-select ${
                  hasBag ? "selected" : ""
                }`}
                onClick={() => choiceHasBag(true)}
              >
                <div className="checkout-has-bag-select-title">
                  {translation.hasBagYesCompany[lang]}
                </div>
                <div className="checkout-has-bag-select-description">
                  <span>{translation.hasBagNoNoteCompany[lang]}</span>
                </div>
              </div>
            </div>

            <div className="checkout-has-bag-select-container">
              <div
                id="checkout-step-3-services-checkbox-has-bag"
                className={`checkout-has-bag-select ${
                  !hasBag ? "selected" : ""
                }`}
                onClick={() => choiceHasBag(false)}
              >
                <div className="checkout-has-bag-select-title">
                  {translation.hasBagNoCompany[lang]}
                </div>
                <div className="checkout-has-bag-select-description">
                  <span>{translation.hasBagNoNoteCompany[lang]}</span>
                  <span>{translation.hasBagSecondPoint[lang]}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="image-block-wrapper">
          <div className="image-block">
            <img src={mailImg} alt="Dobbi Service" />
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({
  currentOrderScreen,
  orderData,
  hasBag,
  currentOrderStep,
  userData,
  formattedAddress,
  userLocation,
  webView,
}) => ({
  currentOrderScreen,
  currentOrderStep,
  orderData,
  hasBag,
  userData,
  formattedAddress,
  userLocation,
  webView,
});

const mapDispatchToProps = (dispatch) => {
  return {
    addOrderData: (data) => dispatch(addOrderData(data)),
    setPlaceOrderData: (data) => dispatch(setPlaceOrderData(data)),
    setHasBag: (data) => dispatch(setHasBag(data)),
    setFormattedAddress: (data) => dispatch(setFormattedAddress(data)),
    setUserLocation: (data) => dispatch(setUserLocation(data)),
    resetSelectedDelivery: (data) => dispatch(resetSelectedDelivery(data)),
    resetSelectedPickup: (data) => dispatch(resetSelectedPickup(data)),
    resetAvailablePickupDate: (data) =>
      dispatch(resetAvailablePickupDate(data)),
    resetAvailableDeliveryDate: (data) =>
      dispatch(resetAvailableDeliveryDate(data)),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(FirstStep);
